import React from 'react';

const CardIcon = ({ type }) => {
    const iconStyle = {
        marginRight: '10px',
        fontSize: '1.5rem'
    };

    switch (type) {
        case 'visa':
            return <span style={iconStyle} className="text-primary">💳</span>;
        case 'mastercard':
            return <span style={iconStyle} className="text-danger">💳</span>;
        case 'amex':
            return <span style={iconStyle} className="text-success">💳</span>;
        case 'discover':
            return <span style={iconStyle} className="text-warning">💳</span>;
        case 'diners':
            return <span style={iconStyle} className="text-info">💳</span>;
        case 'jcb':
            return <span style={iconStyle} className="text-dark">💳</span>;
        default:
            return <span style={iconStyle} className="text-secondary">💳</span>;
    }
};

export default CardIcon;